export default "__VITE_ASSET__C7cDP6C1__"